import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { TooltipOptions } from 'primeng/api';
import { MTooltipComponent } from '../m-tooltip/m-tooltip.component';
import { NgClass, DecimalPipe } from '@angular/common';
import { ProgressBar } from 'primeng/progressbar';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-vertical-bar-comparison',
  templateUrl: './m-vertical-bar-comparison.component.html',
  styleUrls: ['./m-vertical-bar-comparison.component.scss'],
  imports: [MTooltipComponent, NgClass, ProgressBar, DecimalPipe]
})
export class MVerticalBarComparisonComponent implements OnInit {
  @Input() primaryLabel = '';
  @Input() primaryValue!: number | null;
  @Input() primaryDescription = '';
  @Input() secondaryLabel = '';
  @Input() secondaryValue!: number | null;
  @Input() secondaryDescription = '';
  @Input() animate = true;

  primaryHeight = 0;
  secondaryHeight = 0;

  tooltipOptions: TooltipOptions = {
    positionTop: -32,
    showDelay: 800
  };

  ngOnInit(): void {
    if (this.primaryValue !== null && this.secondaryValue !== null) {
      if (this.primaryValue > this.secondaryValue) {
        this.primaryHeight = 100;
        this.secondaryHeight = (this.secondaryValue / this.primaryValue) * 100;
      } else {
        this.secondaryHeight = 100;
        this.primaryHeight = (this.primaryValue / this.secondaryValue) * 100;
      }
    } else {
      this.setEmptyState();
    }
  }

  setEmptyState(): void {
    this.primaryHeight = 100;
    this.secondaryHeight = 100;
  }
}
